var React = require('react');
var PropTypes = React.PropTypes;
var moment = require('moment');
// var Auth = require('../../resources/auth');
var request = require('superagent');
var env = require("../../utils/env");
var Helpers = require("../../utils/helpers");
var StudentClassRes = require("../../resources/studentclass");
var apiDomain = env.domain.api;
// import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import { Link } from 'react-router';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import createConfirm from '../Modal/createConfirm';
import notification from '../Modal/notification';
import async from 'async';
import $ from 'jquery';
import '../../css/components/StudentClasses/StudentClasses.css';
import '../../css/components/StudentAnalytics/ViewStudentMistakesBank.css';

var AnalyticsRes = require('../../resources/analytics');

var months = [
    'January', 'February', 'March', 'April', 'May',
    'June', 'July', 'August', 'September',
    'October', 'November', 'December'
    ];

var ActivityRow = React.createClass({

    retrieveActivitiesForThisMonth: function(retrieveCourseID) {

        var _this = this;
        var options = {};

    //   options.concept_config = {};
    //   options.concept_config.root = retrieveCourseID;//"a234e6f6-a3ee-4bfe-9143-5c52f89ac84c"; //_id of "maths" in concepts table
    //   options.concept_config.leaf = true;
    //   options.concept_config.max_level = 4;

      options.conditions = {};

      var studentID = _this.state._id;//currentURL[currentURL.length-1]; //get the current class ID

      // options.conditions.status = 'student';
      options.skip = 0;
      options.sort = "-dateCreated";
      options.conditions.creator = studentID;
      options.conditions.concepts={
            "$in":[retrieveCourseID]
          }
      ;
    //   options.conditions.type = "USER_CONCEPT_PRACTICE";
    //   options.conditions.$or = [
    //       {
    //       "wrongAnswerCount": {
    //         "$gt": 0
    //       }
    //     }
    //   ];

      var dd = _this.state.day;
      var mm = _this.state.month;
      var yyyy = _this.state.year;

      if (dd < 10) {
        dd = '0' + dd;
      } 
      if (mm < 10) {
        mm = '0' + mm;
      } 

    //   var timeValueDate = '' + yyyy + mm + dd; //time value date here for later pass to link to review each attempt

      var formattedStart = '' + yyyy + '-' + mm + '-' + '01';

      var endTime = '' + yyyy + '-' + mm + '-' + dd; //end date here
      var startTime = formattedStart; //start date here
      
    //   console.log(">>>>>>>>");
    //   console.log("START IS " + startTime);
    //   console.log("END IS " + endTime);
    //   console.log(">>>>>>>>");

      var formattedStartTime = new Date(startTime).valueOf() - 28800000;
      var formattedEndTime = new Date(endTime).valueOf() + 57599999;
      options.conditions.dateCreated = { 
        '$gte':formattedStartTime,
        '$lte':formattedEndTime
      }   
      // options.conditions.status = 'student';

      //call a controller to actually retrieve the activities from the db server
      AnalyticsRes.retrieveStudentActivitesForMonth(options, function(err, res) {

        // if (res.length > 0) {
        //     console.log('Item: ', res);
        // }
        // _this.setState({
        //   isLoading: false,
        // //   data: (!err && res) ? res: [{}]
        // }, () => {

            // console.log("RES LENGTH: " + JSON.stringify(res));
        if (res.length > 0) { //res is an array here

            var upperConcepts = [];
            res.forEach(progress => {

                var buttonDisplayText = "";
                
                var newDate = new Date(progress.dateCreated);//res.timeValue);
                var progressDate = "" + newDate.getDate() + "/" + (newDate.getMonth()+1);
                var whichWeek = _this.getWeek(newDate.getFullYear(),newDate.getMonth()+1);
                // console.log("WHICH WEEK: " + whichWeek);
    
                // console.log('Item: ', res);
                //get the date for this row
                // var timeValue = res[0].timeValue;
                
                // var mm = timeValue.substring(4,6);//timeValue.getDate();
                // var dd = timeValue.substring(6,8);//timeValue.getMonth() + 1;
    
                //TODO: get the concept name for this progress
                // var thisConcept = progress.metadata.mainConcepts[0].title;

                //get worksheet name
                // var worksheetName = progress.title;

                //get question types
                // var questionTypes = progress.questionTypes;
                // var questionTypesString = "";
                // var qLength = questionTypes.length;
                // for (var x = 0; x < qLength; x++) {

                //     var typeString = questionTypes[x];
                //     if (typeString=='11') { questionTypesString += "MCQ"; }
                //     else if (typeString=='12') { questionTypesString += "Structured"; }

                //     if (x==0) { questionTypesString+=", "; }
                // }

                // //get the score for each
                // var scoreString = "";
                // if (progress.finishedAnswerCount > 0) {
                //     scoreString = "" + progress.finalScore + "/" + progress.maxScore;
                // } else {
                //     buttonDisplayText = "Continue"; //show "Continue" on the status button
                // }

                // this.setState({
                
                //     worksheetType:questionTypesString
                // });

                //get the concept ID
                var conceptID = progress.metadata.mainConcepts[0].upperConcept;
                var upperConcept = _this.searchForUpperConcept(conceptID); //get the upper concept for this concept
                // options.conceptID = conceptID;
                console.log("UPPER CONCEPT TITLE IS " + upperConcept.title);
                upperConcepts.push(upperConcept);
            });





            // AnalyticsRes.retrieveConceptForMistake(options, function(err, resConcept) {

            //     console.log('CONCEPT: ', resConcept.title);

                _this.setState({
                    isLoading: false,
                    // conceptTitle: resConcept.title,
                    // conceptDay: dd,
                    // conceptMonth: mm, //January is 0!
                    data: (!err && res) ? res: [{}],
                    upperConcepts:upperConcepts
                }, () => {
                
                });
            // });

        } else {
            _this.setState({
                isLoading:false,
                conceptDay: 0,
                conceptMonth: 0,
                data: (!err && res) ? res: [{}]
            });
        }
            // if (res.length > 0) { _this.renderDataRows(res); }
      });
    //   });
    },

    renderEmptyColumns: function() {

        var result = [],
            _this = this;
        result.push(<td key={0} className="sortable mbColumn wrongQnsColumn">
                        
        </td>);
        result.push(<td key={1} className="sortable mbColumn wrongQnsColumn">
            
        </td>);
        result.push(<td key={2} className="sortable mbColumn wrongQnsColumn">

        </td>);
        result.push(<td key={3} className="sortable mbColumn wrongQnsColumn">
            
        </td>);
        result.push(<td key={4} className="sortable mbColumn wrongQnsColumn">

        </td>);
        // result.push(<td key={5} className="sortable mbColumn wrongQnsColumn">

        // </td>);
        return result;
    },

    renderLeftMostColumn: function(monthNumber,yearNumber,ifParentRow) {
        var result = [],
            _this = this;
        
        var monthName = months[monthNumber-1];
        
        if (!ifParentRow) {

            var mm = monthNumber;//_this.state.conceptMonth;
            var dd = yearNumber;//_this.state.conceptDay;

            // if (mm < 10) { mm = '0' + mm; }
            // if (dd < 10) { dd = '0' + dd; }

            return (
                <td key={'mistakeMonth'} className="sortable mbLeftColumn">
                    &nbsp;&nbsp;&nbsp;&nbsp;{dd}/{mm}
                </td>
            )
        }

        return (
            <td key={'mistakeMonth'} className="sortable mbLeftColumn">
                {monthName} {yearNumber}
            </td>
        )
    },

    renderNoDataRows: function() {

        var result = [],
            _this = this;
        result.push(<td key={0} className="sortable mbColumn wrongQnsColumn">
                        No data
                    </td>);
        result.push(<td key={1} className="sortable mbColumn">
                        
                    </td>);
        result.push(<td key={2} className="sortable mbColumn mbViewColumn">
                        
                    </td>);
        result.push(<td key={3} className="sortable mbColumn mbViewColumn">
                
        </td>);
        result.push(<td key={4} className="sortable mbColumn mbViewColumn">
                
        </td>);
        // result.push(<td key={5} className="sortable mbColumn mbViewColumn">
                
        // </td>);
        return result;
    },

    getWeek: function(year, month_number) {

        var firstOfMonth = new Date(year, month_number-1, 1);
        var lastOfMonth = new Date(year, month_number, 0);

        var used = firstOfMonth.getDay() + lastOfMonth.getDate();

        return Math.ceil( used / 7);
    },

    renderDataRows: function(data,upperConcept) {//, conceptsMap) {
        var result = [],
            _this = this;

        var buttonDisplayText = "View"; //text to display on the status button
        var questionTypesString = ""; //text to display on the worksheet type

        var questionTypes = data.questionTypes;
        
        var qLength = questionTypes.length;
        var ifMCQ = false;
        var ifStructured = false;
        for (var x = 0; x < qLength; x++) {

            var typeString = questionTypes[x];
            if (typeString=='11') { ifMCQ = true; }
            else if (typeString=='21') { ifStructured = true; }

            // if (x==0 && qLength > 1) { questionTypesString+=", "; }
        }

        if (ifMCQ && ifStructured) { questionTypesString = "MCQ, Structured"; }
        else if (ifMCQ) { questionTypesString = "MCQ"; }
        else if (ifStructured) { questionTypesString = "Structured"; }
        
        //get the score for each
        var scoreString = "-";
        if (data.finishedAnswerCount > 0) {
            scoreString = "" + data.finalScore + "/" + data.maxScore;
        } else {
            buttonDisplayText = "View"; //show "Continue" on the status button
        }

        //TODO: get concept name by calling db using concept id again
        result.push(<td key="conceptName" className="mbColumn wrongQnsColumn">
                {data.metadata.mainConcepts[0].title + " (" + upperConcept.title + ")"}
            </td>
        );

        //show name of worksheet
        result.push(<td key="worksheetName" className="mbColumn wrongQnsColumn">
                {data.title}
            </td>
        );

        //show worksheet type
        result.push(<td key="worksheetType" className="mbColumn wrongQnsColumn">
                {questionTypesString}
            </td>
        );

        //show score;
        result.push(<td key="worksheetScore" className="mbColumn wrongQnsColumn">
                {scoreString}
            </td>
        );

        var thisDateTime = new Date(data.dateCreated);
        var mm = thisDateTime.getMonth()+1;
        if (mm < 10) { mm = '0' + mm; }
        var dd = thisDateTime.getDate();
        if (dd < 10) { dd= '0' + dd; }
        var yyyy = thisDateTime.getFullYear();

        var newFormattedDate = yyyy + '' + mm + '' + dd;

        //show review button
        result.push(
            <div key="progressStatus" className="dp-inline-block viewClassButton">
                <Link to={"/student/activity/" + _this.state._id + "/practices/" + data._id + "/" + newFormattedDate}>
                    <button className="btn btn-success btnViewMistake">
                        {buttonDisplayText}
                    </button>
                </Link>
            </div>
        );
        
        return result;
    },

    getInitialState: function() {
        return {
            _id: this.props._id,
            month: this.props.month,
            year: this.props.year,
            day: this.props.day,
            courseID: this.props.courseID,
            conceptDay: 0,
            conceptMonth: 0,
            data: [],
            concepts:this.props.concepts,
            upperConcepts:[],
            isLoading: true,
            // conceptsMap: this.props.conceptsMap,
            // isOpenAssignDialog: false,
            // listReviewers: [],
            // isLoadingReviewers: false,
            // isAssigning: false,
            // assignedCollection: null,
            // assignedReviewers: [],
            // removedReviewers: [],
            mode: this.props.mode,
            sort: this.props.sort
        };
    },

    searchForUpperConcept: function(conceptID) {

        var allConcepts = this.state.concepts;
        var length = allConcepts.children.length;
        for (let z = 0; z < length; z++) {
            
            var child = allConcepts.children[z];
            if (child._id == conceptID) { return child; } //course title
            else { //if not this child, go 1 level deeper for this child

                var innerChildren = child.children;
                var innerLength = innerChildren.length;

                for (let m = 0; m < innerLength; m++) {
                    
                    var innerChild = innerChildren[m];
                    if (innerChild._id == conceptID) { return innerChild; }
                    else { //if still not this inner child, go even 1 level deeper

                        var innerMostChildren = innerChild.children;
                        var innerMostLength = innerMostChildren.length;

                        for (let x = 0; x < innerMostLength; x++) {

                            var innerMostChild = innerMostChildren[x];
                            if (innerMostChild._id == conceptID) { return innerMostChild; }
                        }
                    }
                }
            }
        }

        return null;
    },
    
    componentWillReceiveProps: function(nextProps) {
        this.setState({
          data: nextProps.data || this.state.data,
        //   conceptsMap: nextProps.conceptsMap || this.state.conceptsMap,
        //   mode: nextProps.mode || this.state.mode,
        //   sort: nextProps.sort || this.state.sort
        })
    },

    render: function() {
        var _this = this;
        // const actions = [
        //     <FlatButton
        //         label="Cancel"
        //         primary={true}
        //         onTouchTap={this.closeAssignTaskModal}
        //     />,
        //     <RaisedButton
        //         label={this.state.assignType === 'assign' ? "Assign" : "Re-assign"}
        //         primary={true}
        //         onClick={this.doAssign}/>
        // ];

        if (_this.state.data.length > 0 && !_this.state.isLoading) {

            
            var result = [];
            var dataLength = _this.state.data.length;

            result.push(
                    <tr className="mbRow">
                        {_this.renderLeftMostColumn(_this.state.month,_this.state.year,true)}
                        {_this.renderEmptyColumns()}
                    </tr>
            );

            for (var i = 0; i < dataLength; i++) {
                
                // var timeValue = _this.state.data[i].timeValue;
                var thisDateTime = new Date(_this.state.data[i].dateCreated);

                var mm = thisDateTime.getMonth()+1;
                var dd = thisDateTime.getDate();
                // var mm = timeValue.substring(4,6);//timeValue.getDate();
                // var dd = timeValue.substring(6,8);//timeValue.getMonth() + 1;

                result.push(

                        <tr className="mbRow mbDataRow">
                            {_this.renderLeftMostColumn(mm,dd,false)}
                            {_this.renderDataRows(_this.state.data[i],_this.state.upperConcepts[i])}
                        </tr>
                );
                
            }
            return (
                <tbody>
                    {
                        result.map((data, index) => {
                            return data;
                        })
                    }
                </tbody>
            );
        }
        return (
            <tbody>
                <tr className="mbRow">
                    {_this.renderLeftMostColumn(_this.state.month,_this.state.year,true)}
                    {
                        (_this.state.data.length === 0 && !_this.state.isLoading) &&
                        _this.renderNoDataRows()
                    }
                    {
                    _this.state.isLoading &&
                    <CircularProgress />
                    }
                </tr>
            </tbody>
        );
    },

    componentDidMount: function() {
        var _this = this;
        _this.retrieveActivitiesForThisMonth(_this.state.courseID);
    },
});

module.exports = ActivityRow;




/** WEBPACK FOOTER **
 ** ./src/components/StudentAnalytics/ActivityRow.js
 **/